<div>
  <mat-card appearance="outlined">
    @if (status === 'complete') {
      <mat-card-header>
        <mat-card-title>
          <div>Staging has been successfully moved to production</div>
          <mat-icon class="large-icon success">check_circle</mat-icon>
        </mat-card-title>
      </mat-card-header>
      <mat-card-subtitle>To spin up a new staging environment, go to the staging tab.</mat-card-subtitle>
    } @else {
      <mat-card-header>
        <mat-card-title>
          <div>Oh, shoot! Pushing your staging site live didn’t work.</div>
          <mat-icon class="large-icon failed">error</mat-icon>
        </mat-card-title>
      </mat-card-header>
      <mat-card-subtitle>Please try again.</mat-card-subtitle>
    }
    <button (click)="goToOverview()" color="accent" mat-raised-button>Go to Dashboard</button>
  </mat-card>
</div>
